var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.75C12.41 13.75 12.75 13.41 12.75 13V8C12.75 7.59 12.41 7.25 12 7.25C11.59 7.25 11.25 7.59 11.25 8V13C11.25 13.41 11.59 13.75 12 13.75Z",
    fill: "#6E7191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.92 15.6189C12.87 15.4989 12.8 15.3889 12.71 15.2889C12.61 15.1989 12.5 15.1289 12.38 15.0789C12.14 14.9789 11.86 14.9789 11.62 15.0789C11.5 15.1289 11.39 15.1989 11.29 15.2889C11.2 15.3889 11.13 15.4989 11.08 15.6189C11.03 15.7389 11 15.8689 11 15.9989C11 16.1289 11.03 16.2589 11.08 16.3789C11.13 16.5089 11.2 16.6089 11.29 16.7089C11.39 16.7989 11.5 16.8689 11.62 16.9189C11.74 16.9689 11.87 16.9989 12 16.9989C12.13 16.9989 12.26 16.9689 12.38 16.9189C12.5 16.8689 12.61 16.7989 12.71 16.7089C12.8 16.6089 12.87 16.5089 12.92 16.3789C12.97 16.2589 13 16.1289 13 15.9989C13 15.8689 12.97 15.7389 12.92 15.6189Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.c88f82e84371803440cbc933d6006ed3.svg";
export { ForwardRef as ReactComponent };